export default __webpack_public_path__ + "static/media/giveo_explainer_short.8ea4af18.mp4";